import { h } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";

import { Button, IconButton, Paper, TextField, Tooltip } from "@mui/material";


import NavPrimaryButtonMk2 from "../../theme/NavPrimaryButtonMk2";
import { Box, FormControl } from "@mui/material";

import { useCookies } from "react-cookie";
import { AppContext } from "../../AppContext";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function deleteBkeysCookieAndReload() {
	const cookieName = "_bkeys";
	const exists = document.cookie
		.split("; ")
		.some(cookie => cookie.startsWith(`${cookieName}=`));

	if (!exists) return;

	// Suppression pour le domaine partagé .bkeys.com
	document.cookie = `${cookieName}=; Path=/; Domain=.bkeys.com; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;
	console.log("suppression de cookie");

	window.location.reload();
}


export default function Login(props) {

	const [cookies, setCookie, removeCookie] = useCookies();
	const app = useContext(AppContext);

	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};
	const [values, setValues] = useState(
		window.location.href.startsWith("http://localhost")
			? {
				email: "guillaume.besse+bkgb@telemetis.com",
				password: "******",
				showPassword: false,
			}
			: {
				email: "",
				password: "",
				showPassword: false,
			}
	);

	const handleChange = (prop) => (event) => {
		setValues({ ...values, [prop]: event.target.value });
	};

	const handleKeypress = (e) => {
		//it triggers by pressing the enter key
		if (e.keyCode === 13) {
			submitLogin();
		}
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};
	const submitLogin = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				email: values.email,
				password: values.password,
			}),
		};
		fetch("/anon/login", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setCookie("_bkeys", res.session_token, { path: "/", domain: ".bkeys.com" });
						setCookie("_bkuser", res.name, { path: "/", domain: ".bkeys.com" });
						if (props.r !== undefined) {
							window.location.replace(props.r);
						} else {
							window.location.replace("/dashboard");
						}

						break;
					case "err":
						app.refSnack.current.handleChangeState({ o: true, m: res.reason, s: "error" });
						break;
					default:
						break;
				}
			});
	};
	useEffect(() => {
		console.log("remove cookies ?");
		deleteBkeysCookieAndReload();

		return () => { };
	}, []);
	return (
		<Box style="min-height: 500px" display="flex" justifyContent="center" alignItems="center">
			<Paper elevation={3} style="width: 400px; padding: 10px;">
				<Box display="flex" justifyContent="center" flexDirection="column">
					<FormControl variant="outlined" hiddenLabel>
						<TextField
							id="email"
							name="email"
							variant="outlined"
							style={{
								marginLeft: 0,
								marginRight: 10,
							}}
							placeholder="Email"
							fullWidth
							margin="dense"
							size="small"
							value={values.email}
							onChange={handleChange("email")}
						/>
					</FormControl>

					<FormControl variant="outlined" hiddenLabel>

						<Box display="flex" alignItems="center" justifyContent="space-between" p={1} m={1} style="padding: 0px; margin: 0px;">
							<Box p={1} style="padding: 0px; margin: 0px; flex-grow: 1;">
								<TextField
									id="password"
									name="password"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 10,
									}}
									placeholder="Mot de passe (6 caractères min)"
									fullWidth
									margin="dense"
									size="small"
									value={values.password}
									onChange={handleChange("password")}
									onKeyPress={handleKeypress}
									type={values.showPassword ? "text" : "password"}
								/>
							</Box>
							<Box p={1}>
								<Tooltip title={values.showPassword ? "Masquer le mot de passe" : "Voir le mot de passe"} aria-label="add">
									<IconButton aria-label="mot de passe " onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
										{values.showPassword ? <Visibility /> : <VisibilityOff />}
									</IconButton>
								</Tooltip>
							</Box>
						</Box>
					</FormControl>

					<NavPrimaryButtonMk2
						//style="margin-left: 20px; padding: 10px"
						cb={submitLogin}
						txt="Se connecter"
					/>

					<div style="margin: 10px">
						<Box display="flex" justifyContent="space-between" >
							<Box>
								<Button href="/lostpwd" style="text-transform: none;">
									Mot de passe oublié ?
								</Button>
							</Box>
							<Box>
								<Button href="/inscription" style="text-transform: none;">
									S'inscrire
								</Button>
							</Box>
						</Box>
					</div>
				</Box>
			</Paper>
		</Box>
	);
}
